export default ({ type, isSubscriptionScreen }) => {
  return isSubscriptionScreen && type === 'self'
}
